/*
 * File: DeleteCoursePeriod.ts
 * Author: Austin Robinson
 * Date Created: 6/9/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export type DeleteCoursePeriodParams = string[];

async function deleteCoursePeriods(params: DeleteCoursePeriodParams): Promise<void> {
  // make api call
  await privateApi.delete(`${import.meta.env.VITE_API_BASE_URL}/courses/periods`, {
    data: params,
  });
}

const useDeleteCoursePeriods = createMutation<void, DeleteCoursePeriodParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables) => deleteCoursePeriods(variables),
});

export { deleteCoursePeriods, useDeleteCoursePeriods };
